import { render, staticRenderFns } from "./bespeakService.vue?vue&type=template&id=437115ba&scoped=true"
import script from "./bespeakService.vue?vue&type=script&lang=js"
export * from "./bespeakService.vue?vue&type=script&lang=js"
import style0 from "./bespeakService.vue?vue&type=style&index=0&id=437115ba&prod&lang=css"
import style1 from "./bespeakService.vue?vue&type=style&index=1&id=437115ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437115ba",
  null
  
)

export default component.exports